import { GetProductOffersResponse } from '@iwoca/lapi-client/edge';
import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

export const DOC_TYPES = {
    VAT_RETURN: 'vat_return',
    BANK_STATEMENT: 'bank_statement',
    COMPANY_ACCOUNTS: 'company_accounts',
    MANAGEMENT_ACCOUNTS: 'management_accounts',
    AGED_DEBTOR_REPORT: 'aged_debtor_report',
    OUTSTANDING_DEBT_INFORMATION: 'outstanding_debt_information',
    CASHFLOW_FORECAST: 'cashflow_forecast',
    SELF_ASSESSMENT_TAX_RETURN: 'self_assessment_tax_return'
};

export function hasDocsComplete(state: RootState) {
    const suggestedProduct = getSuggestedProduct(state);
    if (!suggestedProduct) return true;

    return hasProductDocsComplete(suggestedProduct);
}

function getSuggestedProduct(state: RootState) {
    const allProducts = _.get(state, 'api.product_offers.data.products');

    return _.find(allProducts, (product) => product.is_suggested);
}

export function hasProductDocsComplete(
    product: NonNullable<GetProductOffersResponse['data']>['products'][number]
) {
    const incompleteDocumentRequirements = product.data_requirements.filter(
        (dataRequirement) =>
            dataRequirement.category === 'documents' &&
            (dataRequirement.status === 'required' ||
                dataRequirement.status === 'error') &&
            !dataRequirement.is_optional
    );

    return !(
        incompleteDocumentRequirements && incompleteDocumentRequirements.length
    );
}
